export enum LoggerMethods {
  info = 'info',
  debug = 'debug',
  warn = 'warn',
  error = 'error',
}

export type Logger = { [key in LoggerMethods]: (...args: any[]) => void }
